/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Descriptions, message, Divider, Alert } from 'antd';
import { OrderForm } from '../Forms/Orders.form';
import { InvoiceForm } from '../Forms';

export const InvoiceActions = ({
  fn = {
    handler: () => ({}),
    handlerSelected: () => ({}),
    selected: {},
  },
  modal = {
    form: {},
    handler: () => ({}),
    loading: false,
    submit: () => ({}),
    visible: false,
  },
  modalSecondModule = {
    form: {},
    handler: () => ({}),
    loading: false,
    submit: () => ({}),
    visible: false,
  },
}) => {
  const [invoicesData, setInvoicesData] = useState({});
  const [currentTotal, setCurrentTotal] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Sincronizar invoicesData con los valores del formulario (polling)
  React.useEffect(() => {
    let interval;
    if (modal.form && typeof modal.form.getFieldsValue === 'function') {
      interval = window.setInterval(() => {
        const values = modal.form.getFieldsValue();
        setInvoicesData(values);
        setCurrentTotal(values.total);
      }, 300);
    }
    return () => {
      if (interval) {
        window.clearInterval(interval);
      }
    };
  }, [modal.form, fn.selected]);

  const handleInvoiceChange = values => {
    setInvoicesData(values);
    setCurrentTotal(values.total);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await modal.submit(invoicesData);
      modal.handler(false);
    } catch (error) {
      message.error('Ocurrió un error al procesar las facturas');
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return modalSecondModule?.visible ? (
    <Modal
      cancelText="Cancelar"
      centered
      destroyOnClose
      onCancel={() => {
        fn.handlerSelected({});
        modalSecondModule.handler(false);
        modalSecondModule.form.resetFields();
      }}
      onOk={() => modalSecondModule.form.submit()}
      okText={fn.selected?.id ? 'Actualizar' : 'Crear'}
      okButtonProps={{
        loading: modalSecondModule.loading,
      }}
      title={fn.selected?.id ? 'Actualizar Orden' : 'Crear Orden'}
      visible={modalSecondModule.visible}
      width={800}
    >
      <OrderForm
        formRef={modalSecondModule.form}
        oOrder={fn.selected}
        onSubmit={modalSecondModule.submit}
      />
    </Modal>
  ) : (
    <Modal
      cancelText="Cancelar"
      centered
      destroyOnClose
      onCancel={() => {
        fn.handlerSelected({});
        modal.handler(false);
        modal.form.resetFields();
      }}
      onOk={handleSubmit}
      okText="Timbrar"
      okButtonProps={{
        loading: isSubmitting,
        disabled: (() => {
          // Verificar campos requeridos
          const requiredFields = [
            'cliente',
            'email',
            'total',
            'payment_form',
            'payment_method',
          ];

          const hasMissingFields = requiredFields.some(
            field =>
              invoicesData[field] === undefined ||
              invoicesData[field] === null ||
              invoicesData[field] === ''
          );

          // Verificar el total mínimo
          const invoiceTotal = invoicesData.total || 0;
          const hasInvalidTotal = Math.abs(invoiceTotal) < 0.01;

          // Verificar diferencia de totales
          const totalDifferenceInvalid =
            Math.abs(currentTotal - fn.selected.total) > 0.01;

          return hasMissingFields || hasInvalidTotal || totalDifferenceInvalid;
        })(),
      }}
      title={`Crear Factura de Orden ${fn.selected.serie}-${fn.selected.folio}`}
      visible={modal.visible}
    >
      <Descriptions title="Factura Original">
        <Descriptions.Item label="Subtotal">
          {(fn.selected.total_bruto * 1).toFixed(2)}
        </Descriptions.Item>
        <Descriptions.Item label="IVA">
          {(
            (fn.selected.total_neto * 1).toFixed(2) -
            (fn.selected.total_bruto * 1).toFixed(2)
          ).toFixed(2)}
        </Descriptions.Item>
        <Descriptions.Item label="Total">
          {(fn.selected.total_neto * 1).toFixed(2)}
        </Descriptions.Item>
      </Descriptions>

      <Divider />

      <InvoiceForm
        formRef={modal.form}
        onSubmit={{}}
        oOrder={fn.selected}
        onValuesChange={values => handleInvoiceChange(values)}
      />
      <div style={{ marginBottom: 16 }}>
        <Alert
          type={
            currentTotal - fn.selected.total_neto > 0.01 ? 'error' : 'success'
          }
          message={
            currentTotal - fn.selected.total_neto > 0.01
              ? 'El total no puede superar el total inicial'
              : `El total restante de la factura es de $${
                  // eslint-disable-next-line indent
                  (fn.selected.total_neto - currentTotal).toFixed(2)
                }`
          }
        />
      </div>
    </Modal>
  );
};

InvoiceActions.propTypes = {
  fn: PropTypes.any.isRequired,
  modal: PropTypes.shape({
    form: PropTypes.object,
    handler: PropTypes.func,
    loading: PropTypes.bool,
    submit: PropTypes.func,
    visible: PropTypes.bool,
  }),
  modalSecondModule: PropTypes.shape({
    form: PropTypes.object,
    handler: PropTypes.func,
    loading: PropTypes.bool,
    submit: PropTypes.func,
    visible: PropTypes.bool,
  }),
};
